module.exports = __webpack_public_path__ + "a45ad04c04a5ced448b0a99448a8542c.jpg";